<template>
  <div class="details">
    <div class="intro">
      <h4>Emails</h4>
    </div>
    <Table
      :items="contacts"
      :attributes="tableAttributes"
      :options="tableOptions"
      @edit="editEmail"
      @head="addEmail"
    ></Table>
  </div>
</template>

<script>
import Table from '@/components/Table.vue';

export default {
  name: 'SupporterViewEmails',
  components: {
    Table,
  },

  data() {
    return {
      isLoading: false,
      contact: null,
      tableOptions: {
        edit: false,
        pages: [5],
      },
      tableAttributes: [
        { name: 'contact', label: 'Email' },
        { name: 'label', label: 'Label' },
        { name: 'isActive', label: 'Active', type: 'tick' },
        { name: 'isPrimary', label: 'Primary', type: 'tick' },
        { name: 'doNotContact', label: "Don't Contact", type: 'tick' },
      ],
    };
  },

  props: {
    contacts: Array,
    canEdit: Boolean,
  },
  methods: {
    editEmail(contact) {
      this.$emit('editContact', { type: 'email', contact });
    },
    addEmail() {
      this.$emit('addContact', 'email');
    },
  },
};
</script>
